module.exports = __webpack_public_path__ + "static/media/doctor.5b379546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/icons/doctor.svg
// module id = 1672
// module chunks = 0